const listing = gsap.timeline({
    scrollTrigger: {
        trigger: ".listing .content-wrapper",
        start: "0% 50%",
        end: "100% 50%",
        scrub: true,
        // markers: true,
    }
})

listing.to('.listing .fill-text-hover-row', {
    width: "100%",
    stagger: 0.5,
})